// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__hGEL7","switch":"Switch_switch__+R8n+","slider":"Switch_slider__FhiQz"};